import { useEffect, useMemo, useState } from 'react';
import { UnidataUrlData } from '../../../libs/controls/Grid/interfaces';
import {
  stringReplaceByOptions,
  getUrlParamsEntries,
} from '../../../libs/helpers/Utils';
import { mapUrlOptions } from '../utils/mappers/mapUrlOptions';

interface Props {
  api: any;
  data: UnidataUrlData;
  urlParams: {
    [p: string]: string;
  };
  parentId?: string
  id: string
  allValues: {controlid: string, value: string}[]
}

export const prepareFilteredOptions = ({ parentId, allValues, options }) => {
  let filteredOptions;
  if (parentId) {
    // @ts-ignore
    const parentItem = window.dropboxLists?.find(({ key }) => key === parentId);
    const parentSelectedValue = allValues?.find(
      (item) => item.controlid === parentId,
    );
    const selectedOption = parentItem?.options?.find(
      (item) => item.value === parentSelectedValue?.value,
    );

    if (!selectedOption) {
        filteredOptions = options;
    } else {
        filteredOptions = options?.filter((item) => item.cluster === selectedOption.cluster);
    }
  } else {
    filteredOptions = options;
  }

  return filteredOptions;
};

export const useGetOptionsByData = ({ data, api, urlParams, parentId, id, allValues }: Props) => {
  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<UnidataUrlData['extra'][]>([]);

  const memoizedData = useMemo(() => data, [data?.query, data?.url]);

  useEffect(() => {
    if (isInit) setIsInit(false);
  }, [memoizedData]);

  const getOptions = (forceReinit = false) => {
    if (isInit && !forceReinit) return;

    let _urlParams = '';

    // мапим нужные части ctrl.dataMapped
    const dataMapped = !!data ? { ...data } : undefined;
    if (!!dataMapped && !!dataMapped.url) {
      dataMapped.url = stringReplaceByOptions(dataMapped?.url, api.options);
    }

    if (dataMapped?.urlParams && urlParams) {
      _urlParams = getUrlParamsEntries(dataMapped, urlParams);
    }

    if (dataMapped?.url) {
      setIsLoading(true);

      if (!api.options.baseUrl) {
        new Error('Исправьте конфигурацию, не добавлен baseUrl');
      }

      api?.moduleApi?.get(
        `${api.options.baseUrl}${dataMapped.url}${_urlParams}`,
        dataMapped?.query || null,
        {
          success: (response) => {
            const options = mapUrlOptions(response.data, dataMapped?.extra);

            // текущая реализация загрузки данных не позволяет нормально сохранять
            // данные нужны для общения зависимых селектов
            // @ts-ignore
            if (!window.dropboxLists) {
              // @ts-ignore
              window.dropboxLists = [];
            }
            // @ts-ignore
            window.dropboxLists.push({key: id, options});

            if (response.data.length > 0 && !isInit) {
              setIsInit(true);
            }

            setOptions(prepareFilteredOptions({ parentId, allValues, options }));
            setIsLoading(false);
          },
          error: () => {
            setIsLoading(false);
          },
        },
      );
    }
  };

  return { isLoading, options, getOptions };
};
